// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file accounts/accounts_revenue.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { RevenueItem } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.AccountsRevenueRequest
 */
export class AccountsRevenueRequest extends Message<AccountsRevenueRequest> {
  /**
   * Start date for the report
   *
   * @generated from field: int32 start_date = 1;
   */
  startDate = 0;

  /**
   * End date for the report
   *
   * @generated from field: int32 end_date = 2;
   */
  endDate = 0;

  /**
   * Whether to calculate moving average
   *
   * @generated from field: bool calculate_moving_average = 3;
   */
  calculateMovingAverage = false;

  /**
   * Period for moving average calculation
   *
   * @generated from field: int32 moving_average_period = 4;
   */
  movingAveragePeriod = 0;

  constructor(data?: PartialMessage<AccountsRevenueRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.AccountsRevenueRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "start_date", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "end_date", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "calculate_moving_average", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "moving_average_period", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AccountsRevenueRequest {
    return new AccountsRevenueRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AccountsRevenueRequest {
    return new AccountsRevenueRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AccountsRevenueRequest {
    return new AccountsRevenueRequest().fromJsonString(jsonString, options);
  }

  static equals(a: AccountsRevenueRequest | PlainMessage<AccountsRevenueRequest> | undefined, b: AccountsRevenueRequest | PlainMessage<AccountsRevenueRequest> | undefined): boolean {
    return proto3.util.equals(AccountsRevenueRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.AccountsRevenueResponse
 */
export class AccountsRevenueResponse extends Message<AccountsRevenueResponse> {
  /**
   * List of revenue items
   *
   * @generated from field: repeated com.neulink.pharmacy.RevenueItem revenue_items = 1;
   */
  revenueItems: RevenueItem[] = [];

  constructor(data?: PartialMessage<AccountsRevenueResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.AccountsRevenueResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "revenue_items", kind: "message", T: RevenueItem, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AccountsRevenueResponse {
    return new AccountsRevenueResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AccountsRevenueResponse {
    return new AccountsRevenueResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AccountsRevenueResponse {
    return new AccountsRevenueResponse().fromJsonString(jsonString, options);
  }

  static equals(a: AccountsRevenueResponse | PlainMessage<AccountsRevenueResponse> | undefined, b: AccountsRevenueResponse | PlainMessage<AccountsRevenueResponse> | undefined): boolean {
    return proto3.util.equals(AccountsRevenueResponse, a, b);
  }
}

